export default "__VITE_ASSET__BjkOV2vu__"